<template>
  <div>
    <div>
      <el-button size="mini" type="primary" @click="startFlow">发起流程</el-button>
      <el-button size="mini" @click="setComponentId('FurnishList')">返回</el-button>
    </div>
    <div style="margin: 0 auto;display: table;">
      <table align="center" cellspacing="0" class="Table"
             style="border-collapse:collapse; border:none; font-family:'Times New Roman'; font-size:13px">
        <tbody>
        <tr>
          <td colspan="6" style="border-bottom:1px solid black; border-left:none; border-right:none; border-top:none; vertical-align:bottom; width:709px">
            <p style="text-align:left">
              <strong>
              <span style="font-size:11.0000pt; display: flex;flex-direction: row;justify-content: space-between">
                <span style="font-family:宋体">广东中奥物业管理有限公司</span>
                <span style="font-family:宋体">P41-01-01</span>
              </span>
              </strong>
            </p>
          </td>
        </tr>
        <tr>
          <td colspan="6"
              style="border-bottom:none; border-left:none; border-right:none; border-top:none; vertical-align:center; width:709px">
            <p style="text-align:center"><span style="font-size:10.5pt"><span
              style="font-family:'Times New Roman',serif"><strong><span style="font-size:20.0000pt"><span
              style="font-family:黑体,serif"><strong><span
              style="font-family:黑体,serif">装修申请表</span></strong></span></span></strong></span></span></p>
          </td>
        </tr>
        <tr>
          <td colspan="6"
              style="border-bottom:none; border-left:none; border-right:none; border-top:none; vertical-align:center; width:709px">
            <p style="text-align:justify">
            <span style="font-size:10.5pt;display: flex;flex-direction: row;justify-content: space-between">
              <span style="font-family:宋体">办理时间：{{form.ApplyDate}}</span>
              <span style="font-family:黑体"><strong>N0： {{ form.FitmentID }}</strong></span>
            </span>
            </p>
          </td>
        </tr>
        <tr>
          <td
            style="border-bottom:1px solid black; border-left:1px solid black; border-right:1px solid black; border-top:1px solid black; vertical-align:center; width:106px">
            <p style="text-align:center"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
              style="font-size:12.0000pt"><span style="font-family:'Courier New'"><span style="font-family:宋体">装修单</span></span></span><span
              style="font-size:12.0000pt"><span style="font-family:宋体"><span style="font-family:宋体">元</span></span></span></span></span>
            </p>
          </td>
          <td
            style="border-bottom:1px solid black; border-left:none; border-right:1px solid black; border-top:1px solid black; vertical-align:center; width:147px">
            <p style="text-align:center">{{form.house_name}}</p>
          </td>
          <td
            style="border-bottom:1px solid black; border-left:none; border-right:1px solid black; border-top:1px solid black; vertical-align:center; width:112px">
            <p style="text-align:center"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
              style="font-size:12.0000pt"><span style="font-family:'Courier New'"><span style="font-family:宋体">业主姓名</span></span></span></span></span>
            </p>
          </td>
          <td
            style="border-bottom:1px solid black; border-left:none; border-right:1px solid #000000; border-top:1px solid black; vertical-align:center; width:120px">
            <p style="text-align:center">{{ form.customer_name }}</p>
          </td>
          <td
            style="border-bottom:1px solid black; border-left:none; border-right:1px solid black; border-top:1px solid black; vertical-align:center; width:84px">
            <p style="text-align:center"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
              style="font-size:12.0000pt"><span style="font-family:'Courier New'"><span style="font-family:宋体">联系电话</span></span></span></span></span>
            </p>
          </td>
          <td
            style="border-bottom:1px solid black; border-left:none; border-right:1px solid #000000; border-top:1px solid black; vertical-align:center; width:140px">
            <p style="text-align:center">{{ form.FaceTakeChargeByPhone }}</p>
          </td>
        </tr>
        <tr>
          <td
            style="border-bottom:1px solid black; border-left:1px solid black; border-right:1px solid black; border-top:none; vertical-align:center; width:106px">
            <p style="text-align:center"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
              style="font-size:10.5000pt"><span style="font-family:'Courier New'"><span style="font-family:宋体">装修商</span></span></span></span></span>
            </p>
          </td>
          <td colspan="3"
              style="border-bottom:1px solid black; border-left:none; border-right:1px solid black; border-top:none; vertical-align:center; width:379px">
            <p style="text-align:center">{{ form.CompanyID }}</p>
          </td>
          <td
            style="border-bottom:1px solid black; border-left:none; border-right:1px solid black; border-top:none; vertical-align:center; width:84px">
            <p style="text-align:center"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
              style="font-size:10.5000pt"><span style="font-family:'Courier New'"><span style="font-family:宋体">资质等级</span></span></span></span></span>
            </p>
          </td>
          <td
            style="border-bottom:1px solid black; border-left:none; border-right:1px solid #000000; border-top:none; vertical-align:center; width:140px">
            <p style="text-align:justify">{{ form.CompanyLevel }}</p>
          </td>
        </tr>
        <tr>
          <td
            style="border-bottom:1px solid black; border-left:1px solid black; border-right:1px solid black; border-top:none; vertical-align:center; width:106px">
            <p style="text-align:center"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
              style="font-size:12.0000pt"><span style="font-family:'Courier New'"><span style="font-family:宋体">负责人</span></span></span></span></span>
            </p>
          </td>
          <td
            style="border-bottom:1px solid black; border-left:none; border-right:1px solid black; border-top:none; vertical-align:center; width:147px">
            <p style="text-align:center">{{ form.CompanyMaster }}</p>
          </td>
          <td
            style="border-bottom:1px solid black; border-left:none; border-right:1px solid black; border-top:none; vertical-align:center; width:112px">
            <p style="text-align:center"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
              style="font-size:12.0000pt"><span style="font-family:'Courier New'"><span style="font-family:宋体">联系电话</span></span></span></span></span>
            </p>
          </td>
          <td colspan="3"
              style="border-bottom:1px solid black; border-left:none; border-right:1px solid #000000; border-top:none; vertical-align:center; width:344px">
            <p style="text-align:center">{{form.CompanyMasterPhone}}</p>
          </td>
        </tr>
        <tr>
          <td
            style="border-bottom:1px solid black; border-left:1px solid black; border-right:1px solid black; border-top:none; vertical-align:center; width:106px">
            <p style="text-align:center"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
              style="font-size:12.0000pt"><span style="font-family:'Courier New'"><span style="font-family:宋体">装修时间</span></span></span></span></span>
            </p>
          </td>
          <td colspan="5"
              style="border-bottom:1px solid black; border-left:none; border-right:1px solid #000000; border-top:none; vertical-align:center; width:603px">
            <p style="text-align:center"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
              style="font-size:10.5000pt"><span style="font-family:'Courier New'"><span
              style="font-family:宋体">从 {{form.BeginDate}} 起至 {{form.EndDate}} 止　（共 {{form.FitmentDays}} 天）</span></span></span></span></span></p>
          </td>
        </tr>
        <tr>
          <td colspan="4"
              style="border-bottom:1px solid black; border-left:1px solid black; border-right:1px solid #000000; border-top:none; vertical-align:center; width:485px">
            <p style="text-align:center"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
              style="font-size:12.0000pt"><span style="font-family:'Courier New'"><span
              style="font-family:宋体">装修申请项目</span></span></span></span></span></p>
          </td>
          <td colspan="2"
              style="border-bottom:1px solid black; border-left:none; border-right:1px solid #000000; border-top:none; vertical-align:center; width:224px">
            <p style="text-align:center"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
              style="font-size:12.0000pt"><span style="font-family:'Courier New'"><span style="font-family:宋体">审核意见</span></span></span></span></span>
            </p>
          </td>
        </tr>
        <tr>
          <td colspan="4"
              style="border-bottom:1px solid black; border-left:1px solid black; border-right:1px solid #000000; border-top:none; vertical-align:center; width:485px">
            <p style="text-align:justify">
              &nbsp;&nbsp;&nbsp;&nbsp;<el-checkbox v-model="checked_item1[0]">非外墙、承重墙（柱、梁）墙体拆改、加建（轻质材料）</el-checkbox>
            </p>
          </td>
          <td colspan="2" rowspan="4"
              style="border-bottom:1px solid #000000; border-left:none; border-right:1px solid #000000; border-top:none; vertical-align:top; width:224px">
            <p style="text-align:left"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
              style="font-size:12.0000pt"><span style="font-family:'Courier New'"><span style="font-family:宋体">&nbsp;客户服务部：</span></span></span>&nbsp;</span></span>
            </p>
          </td>
        </tr>
        <tr>
          <td colspan="4"
              style="border-bottom:1px solid black; border-left:1px solid black; border-right:1px solid #000000; border-top:none; vertical-align:center; width:485px">
            <p style="text-align:justify">
              &nbsp;&nbsp;&nbsp;&nbsp;<el-checkbox v-model="checked_item1[1]">空调、热水器安装、改动，墙面开孔</el-checkbox>
            </p>
          </td>
        </tr>
        <tr>
          <td colspan="4"
              style="border-bottom:1px solid black; border-left:1px solid black; border-right:1px solid #000000; border-top:none; vertical-align:center; width:485px">
            <p style="text-align:justify">
              &nbsp;&nbsp;&nbsp;&nbsp;<el-checkbox v-model="checked_item1[2]">天花吊顶、大型灯饰吊装</el-checkbox>
            </p>
          </td>
        </tr>
        <tr>
          <td colspan="4"
              style="border-bottom:1px solid black; border-left:1px solid black; border-right:1px solid #000000; border-top:none; vertical-align:center; width:485px">
            <p style="text-align:justify">
              &nbsp;&nbsp;&nbsp;&nbsp;<el-checkbox v-model="checked_item1[3]">厨、卫防水处理</el-checkbox>
            </p>
          </td>
        </tr>
        <tr>
          <td colspan="4"
              style="border-bottom:1px solid black; border-left:1px solid black; border-right:1px solid #000000; border-top:none; vertical-align:center; width:485px">
            <p style="text-align:justify">
              &nbsp;&nbsp;&nbsp;&nbsp;<el-checkbox v-model="checked_item1[4]">水、电、气、供暖等布线（管），安装</el-checkbox>
            </p>
          </td>
          <td colspan="2" rowspan="5"
              style="border-bottom:1px solid #000000; border-left:none; border-right:1px solid #000000; border-top:none; vertical-align:top; width:224px">
            <p style="text-align:left"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
              style="font-size:12.0000pt"><span style="font-family:'Courier New'"><span style="font-family:宋体">&nbsp;工程维保部：</span></span></span></span></span>
            </p>
          </td>
        </tr>
        <tr>
          <td colspan="4"
              style="border-bottom:1px solid black; border-left:1px solid black; border-right:1px solid #000000; border-top:none; vertical-align:center; width:485px">
            <p style="text-align:justify">
              &nbsp;&nbsp;&nbsp;&nbsp;<el-checkbox v-model="checked_item1[5]">地板铺设</el-checkbox>
            </p>
          </td>
        </tr>
        <tr>
          <td colspan="4"
              style="border-bottom:1px solid black; border-left:1px solid black; border-right:1px solid #000000; border-top:none; vertical-align:center; width:485px">
            <p style="text-align:justify">
              &nbsp;&nbsp;&nbsp;&nbsp;<el-checkbox v-model="checked_item1[6]">木工制作</el-checkbox>
            </p>
          </td>
        </tr>
        <tr>
          <td colspan="4"
              style="border-bottom:1px solid black; border-left:1px solid black; border-right:1px solid #000000; border-top:none; vertical-align:center; width:485px">
            <p style="text-align:justify">
              &nbsp;&nbsp;&nbsp;&nbsp;<el-checkbox v-model="checked_item1[7]">油漆</el-checkbox>
            </p>
          </td>
        </tr>
        <tr>
          <td colspan="4"
              style="border-bottom:1px solid black; border-left:1px solid black; border-right:1px solid #000000; border-top:none; vertical-align:center; width:485px">
            <p style="text-align:justify">
              &nbsp;&nbsp;&nbsp;&nbsp;<el-checkbox v-model="checked_item1[8]">动火作业</el-checkbox>
            </p>
          </td>
        </tr>
        <tr>
          <td colspan="4"
              style="border-bottom:1px solid black; border-left:1px solid black; border-right:1px solid #000000; border-top:none; vertical-align:center; width:485px">
            <p style="text-align:justify">
              &nbsp;&nbsp;&nbsp;&nbsp;<el-checkbox v-model="checked_item1[9]">灯、牌、广告等安装（商业类）</el-checkbox>
            </p>
          </td>
          <td colspan="2" rowspan="4"
              style="border-bottom:1px solid #000000; border-left:none; border-right:1px solid #000000; border-top:none; vertical-align:top; width:224px">
            <p style="text-align:left"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
              style="font-size:12.0000pt"><span style="font-family:'Courier New'"><span style="font-family:宋体">&nbsp;秩序维护部：</span></span></span></span></span>
            </p>
          </td>
        </tr>
        <tr>
          <td colspan="4"
              style="border-bottom:1px solid black; border-left:1px solid black; border-right:1px solid #000000; border-top:none; vertical-align:center; width:485px">
            <p style="text-align:justify">
              &nbsp;&nbsp;&nbsp;&nbsp;<el-checkbox v-model="checked_item1[10]">消防（弱电）系统改动</el-checkbox>
            </p>
          </td>
        </tr>
        <tr>
          <td colspan="4" rowspan="2"
              style="border-bottom:1px solid #000000; border-left:1px solid black; border-right:1px solid #000000; border-top:none; vertical-align:top; width:485px">
            <p style="text-align:justify">
              &nbsp;&nbsp;&nbsp;&nbsp;<el-checkbox v-model="checked_item1[11]">其他：</el-checkbox>
            </p>
          </td>
        </tr>
        <tr>
        </tr>
        <tr>
          <td rowspan="2"
              style="border-bottom:1px solid black; border-left:1px solid black; border-right:1px solid black; border-top:none; vertical-align:center; width:106px">
            <p style="text-align:center"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
              style="font-size:12.0000pt"><span style="font-family:'Courier New'"><span
              style="font-family:宋体">提供</span><span style="font-family:宋体">资料</span></span></span></span></span></p>
          </td>
          <td colspan="5"
              style="border-bottom:none; border-left:none; border-right:1px solid #000000; border-top:none; vertical-align:center; width:603px">
            <p style="text-align:left"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
              style="font-size:9.0000pt"><span style="font-family:'Courier New'"><span
              style="font-family:宋体">业主</span>/<span style="font-family:宋体">装修商提供： </span></span></span></span></span></p>

            <p style="text-align:left;margin: 5px;">
              <el-checkbox-group v-model="checked_item2">
                &nbsp;&nbsp;&nbsp;&nbsp; <el-checkbox v-for="(item,index) in checked_item2_list" :key="index" :label="item"></el-checkbox>
              </el-checkbox-group>
            </p>

            <p style="text-align:left;margin: 5px;">
              <el-checkbox-group v-model="checked_item3">
                &nbsp;&nbsp;&nbsp;&nbsp; <el-checkbox v-for="(item,index) in checked_item3_list" :key="index" :label="item"></el-checkbox>
              </el-checkbox-group>
            </p>
          </td>
        </tr>
        <tr>
          <td colspan="5"
              style="border-bottom:none; border-left:none; border-right:1px solid #000000; border-top:none; vertical-align:center; width:603px">
            <p style="text-align:left;margin: 5px;">
              <el-checkbox-group v-model="checked_item4">
                &nbsp;&nbsp;&nbsp;&nbsp; <el-checkbox v-for="(item,index) in checked_item4_list" :key="index" :label="item"></el-checkbox>
              </el-checkbox-group>
            </p>
          </td>
        </tr>
        <tr>
          <td rowspan="4"
              style="border-bottom:1px solid #000000; border-left:1px solid black; border-right:1px solid black; border-top:none; vertical-align:center; width:106px">
            <p style="text-align:center"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
              style="font-size:12.0000pt"><span style="font-family:'Courier New'"><span
              style="font-family:宋体">装</span><span style="font-family:宋体">修</span><span
              style="font-family:宋体">保</span><span style="font-family:宋体">证</span> </span></span></span></span></p>
          </td>
          <td colspan="5" rowspan="3"
              style="border-bottom:none; border-left:none; border-right:1px solid #000000; border-top:1px solid black; vertical-align:center; width:603px">
            <p style="text-align:left"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
              style="font-size:11.0000pt"><span style="font-family:'Courier New'">&nbsp;&nbsp;&nbsp;<span
              style="font-family:宋体">本业主及装修商负责人承诺：本单位在装修期间的装修行为将严格遵守本物业《装修指南》、《装饰装修服务协议》有关之管理规定。本人或装修单位如违反有关规定，包括个人行为所造成之损坏或投诉，物业公司有权向业主（租户）装修单位追讨一切引起之损失。</span></span></span></span></span>
            </p>
          </td>
        </tr>
        <tr>
        </tr>
        <tr>
        </tr>
        <tr>
          <td colspan="5"
              style="border-bottom:1px solid black; border-left:none; border-right:1px solid #000000; border-top:none; vertical-align:center; width:603px">
            <p style="text-align:left"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
              style="font-size:12.0000pt"><span style="font-family:'Courier New'"><span
              style="font-family:宋体">&nbsp;业主确认：</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="font-family:宋体">装修商负责人确认：</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
              style="font-family:宋体">经办人确认：</span></span></span></span></span></p>
          </td>
        </tr>
        <tr>
          <td rowspan="2"
              style="border-bottom:1px solid black; border-left:1px solid black; border-right:1px solid black; border-top:none; vertical-align:center; width:106px">
            <p style="text-align:center"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
              style="font-size:10.5000pt"><span style="font-family:'Courier New'"><span
              style="font-family:宋体">项目经理审核</span></span></span></span></span></p>
          </td>
          <td colspan="5" rowspan="2"
              style="border-bottom:1px solid black; border-left:none; border-right:1px solid #000000; border-top:none; vertical-align:center; width:603px">
            <p style="text-align:left">&nbsp;</p>
          </td>
        </tr>
        <tr>
        </tr>
        <tr>
          <td
            style="border-bottom:none; border-left:1px solid black; border-right:1px solid black; border-top:none; vertical-align:center; width:106px">
            <p style="text-align:center"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
              style="font-size:10.5000pt"><span style="font-family:'Courier New'"><span style="font-family:宋体">审后回复</span></span></span></span></span>
            </p>
          </td>
          <td colspan="5"
              style="border-bottom:1px solid black; border-left:none; border-right:1px solid #000000; border-top:none; vertical-align:center; width:603px">
            <p style="text-align:left"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
              style="font-size:10.5000pt"><span style="font-family:'Courier New'"><span
              style="font-family:宋体">&nbsp;回复情况：</span></span></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
              style="font-size:10.5000pt"><span style="font-family:'Courier New'"><span style="font-family:宋体">时间：</span> &nbsp;&nbsp;&nbsp;&nbsp;</span></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
              style="font-size:10.5000pt"><span style="font-family:'Courier New'">&nbsp;&nbsp;&nbsp;<span
              style="font-family:宋体">经办人：</span> </span></span></span></span></p>
          </td>
        </tr>
        <tr>
          <td
            style="border-bottom:1px solid black; border-left:1px solid black; border-right:1px solid black; border-top:1px solid black; vertical-align:center; width:106px">
            <p style="text-align:center"><span style="font-size:10.5pt"><span style="font-family:'Times New Roman'"><span
              style="font-size:10.5000pt"><span style="font-family:'Courier New'"><span
              style="font-family:宋体">备注</span></span></span></span></span></p>
          </td>
          <td colspan="5"
              style="border-bottom:1px solid black; border-left:none; border-right:1px solid #000000; border-top:none; vertical-align:center; width:603px">
            <p style="text-align:left">&nbsp;</p>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "FurnishApply",
  inject:['mainObj','componentId','setComponentId','ProcessState','setProcessState'],
  data() {
    return {
      form:{},
      checked_item1:[],
      checked_item2_list:[
        '装修平面图',
        '立面图',
        '室内布置图',
        '给排水改动图',
        '电路图',
      ],
      checked_item2:[],
      checked_item3_list:[
        '门面效果图',
        '立面施工图',
      ],
      checked_item3:[],
      checked_item4_list:[
        '装修单位营业执照复印件',
        '装修单位资质证复印件',
        '专业人员资格证书',
      ],
      checked_item4:[],

    }
  },
  mounted() {
    const that = this;
    that.getData()
  },
  methods:{
    getData(){
      const that = this;
      ERP.postRequest({url:"admin/HouseFurnish/getFurnish",data:{house_id:that.mainObj.house_id,id:that.mainObj.id}},ret=>{
        if(ret.code){
          that.setProcessState(ret.data.ProcessState);
          that.form=ret.data;
        }else{
          this.$msgbox.alert(ret.msg||"查询失败")
        }
      })
    },
    getDay(start_time,end_time){
      if(start_time&&end_time){
        return moment(end_time).diff(moment(start_time), 'days');
      }else {
        return 0;
      }
    },
    startFlow(){
      const that=this;
      let timeValue=(new Date()).getTime();
      let batch_number="flow_"+timeValue;
      (!window.__FLOW_FROM_DATA__)&&(window.__FLOW_FROM_DATA__={});
      window.__FLOW_FROM_DATA__[batch_number]=that.form;
      ERP.navigateTo(`/flow/FlowView?sheet_id=12&master_id=80&batch_number=${batch_number}&timeValue=${timeValue}`)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../common";
</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/components/furnish/FurnishApply.vue